module.exports = __webpack_public_path__ + "52ad483a4092e31209f1a68d0e4e6759.png";